import React from 'react'
import PropTypes from 'prop-types'

import { P } from 'ui/bend'
import { useActiveMembershipContext } from '../ActiveMembershipStore'
import { humanReadableDate, humanReadableTime } from './formatTimes'

const Unlimited = () => {
  const {
    membershipInfo: { subscriptionEndTime }
  } = useActiveMembershipContext()

  const date = new Date(subscriptionEndTime)
  return (
    <P color='primary'>
      As an Alo Moves unlimited member, you receive all the benefits of our
      services
      {subscriptionEndTime &&
        ` until ${humanReadableDate(date)} at ${humanReadableTime(date)}`}
      .
    </P>
  )
}

Unlimited.propTypes = {
  subscriptionEndTime: PropTypes.string.isRequired
}

export default Unlimited
